import styled, {css} from 'styled-components';

//helpers
import {headingFontSizes} from 'styles/vars';

const getFontSize = p => {
  const size = headingFontSizes[p.size] ? p.size : 'normal';
  return headingFontSizes[size][p.device];
};

const lineHeight = 1.5;

export const Heading = styled.div`
  font-size: ${getFontSize}rem;
  font-weight: normal;
  line-height: ${lineHeight};
  margin: 0;
  color: inherit;

  ${p =>
    p.ellipsis &&
    `
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `};

  ${p =>
    p.maxLines &&
    css`
      max-height: ${p => getFontSize(p) * lineHeight * p.maxLines}rem;
      overflow: hidden;
    `}
`;
